import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@fluentui/react/lib/Button';

const iconButtonStyles = {
  root: {
    color: '#424242',
    marginLeft: 'auto',
    marginTop: '4px',
    marginRight: '2px',
  },
};

const cancelIcon = { iconName: 'Cancel' };

export const CloseIconButton = ({ closeButtonAriaLabel, onClick }) => (
  <IconButton
    styles={iconButtonStyles}
    iconProps={cancelIcon}
    ariaLabel={closeButtonAriaLabel}
    onClick={onClick}
  />
);

CloseIconButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  closeButtonAriaLabel: PropTypes.string.isRequired,
};
